import { observer } from 'mobx-react-lite';
import * as React from 'react';
import SlidesModel from '../../model/SlidesModel';

interface FCProps {}

const SlideLoaderIndicator: React.FC<FCProps> = observer(({}) => {
  let jsx = [];

  SlidesModel.currentActiveSliderTransitions.forEach((transition) => {
    jsx.push(
      <div
        style={{
          position: 'fixed',
          top: `0px`,
          left: `0px`,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <div
          style={{
            color: 'white',
            fontSize: '24px'
          }}>
          Loading...
        </div>
      </div>
    );
  });

  return jsx;
});

export default SlideLoaderIndicator;
